import React from 'react';
import './kbd.scss';

const Kbd = (props) => <kbd className="kbd" {...props} />;
export default Kbd;
